import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ASSETS } from "../lib/assets";

const KEY = "monoton_intro_seen_v1";

export const LogoIntro = () => {
  const reduce = useReducedMotion();
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(KEY) !== "1";
  });

  useEffect(() => {
    if (!show) return;
    const total = reduce ? 900 : 1800;
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setShow(false);
    }, total);
    return () => clearTimeout(t);
  }, [show, reduce]);

  const skip = () => {
    sessionStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="logo-intro"
          onClick={skip}
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ background: "var(--ink)" }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(circle at 50% 50%, rgba(244,152,0,0.15), transparent 55%)",
            }}
          />
          <motion.img
            src={ASSETS.logo}
            alt="Monoton"
            className="relative"
            style={{
              width: "clamp(140px, 18vw, 280px)",
              height: "auto",
              mixBlendMode: "screen",
              filter: "drop-shadow(0 0 60px rgba(244,152,0,0.35))",
            }}
            initial={reduce ? { opacity: 0 } : { opacity: 0, scale: 0.94 }}
            animate={reduce ? { opacity: 1 } : { opacity: 1, scale: 1 }}
            transition={{ duration: reduce ? 0.4 : 0.6, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
